(function () {
  var productCache = Object.create(null);
  var CARD_SELECTOR = 'a.findify-components--cards--product, [data-element="card"].findify-components--cards--product';
  var IMAGE_WRAPPER_SELECTOR = '.findify-components--cards--product__image .findify-components-common--image';

  function getProductHandle(card) {
    var href = card.getAttribute('href');

    if (!href) {
      var link = card.querySelector('a[href*="/products/"]');
      href = link ? link.getAttribute('href') : null;
    }

    if (!href) return null;

    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return productCache[handle];
    }

    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) {
      return 'https:' + url;
    }
    return url;
  }

  function getImageElement(imageWrapper) {
    var img = imageWrapper.querySelector('img.findify-components-common--image__image');

    if (!img) {
      img = imageWrapper.querySelector('img');
    }

    if (!img) {
      img = document.createElement('img');
      img.className = 'findify-components-common--image__image';
      img.loading = 'lazy';
      img.decoding = 'async';
      imageWrapper.appendChild(img);
    }

    return img;
  }

  function isImageEmpty(img) {
    if (!img) return true;

    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    return src.trim() === '';
  }

  function setProductImage(card, imageUrl, altText) {
    var imageWrapper = card.querySelector(IMAGE_WRAPPER_SELECTOR);
    if (!imageWrapper || !imageUrl) return false;

    var img = getImageElement(imageWrapper);
    img.src = imageUrl;
    img.alt = altText || img.alt || '';
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('srcset');
    img.style.display = '';
    card.setAttribute('data-findify-image-fixed', 'true');
    return true;
  }

  function fixCardImage(card) {
    if (card.getAttribute('data-findify-image-fixed') === 'true') {
      return;
    }

    var handle = getProductHandle(card);
    if (!handle) return;

    var imageWrapper = card.querySelector(IMAGE_WRAPPER_SELECTOR);
    if (!imageWrapper) return;

    var img = imageWrapper.querySelector('img.findify-components-common--image__image, img');
    var needsShopifyImage = isImageEmpty(img);

    function loadShopifyImage() {
      fetchProduct(handle).then(function (product) {
        if (!product || !product.featured_image) return;

        setProductImage(
          card,
          normalizeImageUrl(product.featured_image),
          product.title
        );
      });
    }

    if (needsShopifyImage) {
      loadShopifyImage();
      return;
    }

    img.addEventListener('error', function onError() {
      img.removeEventListener('error', onError);
      card.removeAttribute('data-findify-image-fixed');
      loadShopifyImage();
    }, { once: true });

    if (img.complete && img.naturalWidth === 0) {
      loadShopifyImage();
    }
  }

  function fixAllCards(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(CARD_SELECTOR).forEach(fixCardImage);
  }

  function init() {
    fixAllCards(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(CARD_SELECTOR)) {
            fixCardImage(node);
          }

          fixAllCards(node);
        });
      });
    });

    var containers = document.querySelectorAll('[data-findify]');
    var target = containers.length ? containers : [document.body];

    target.forEach(function (container) {
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
